export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f834205456e77d3561f6d0894cd20757a010d3b61&name=fetchTypeahead!'